import {Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation} from '@angular/core';
import { ParkProvider } from '@providers/park.provider';
import { Area } from '@core/area';
import { BroadcastService } from '@core/broadcast/broadcast.service';
import { LandEvent } from '@core/broadcaster/LandEvent';
import { OpenLandModalEvent } from '../../../events/OpenLandModalEvent';
import { NotificationService } from '@core/notification/notification.service';
import { RefreshEvent } from '../../../events/RefreshEvent';
import { ThingsUtil } from '../../../util/things';

@Component({
  selector: 'things-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ThingsCardComponent implements OnInit {

  @Input()
  public thing: any;

  public hasIcon: boolean;
  public icon: string;
  public isResource: boolean;

  //public fakeThresholds = [{start: "11:00", end: "19:00", threshold: 50}, {start: "11:00", end: "19:00", threshold: 50}, {start: "11:00", end: "19:00", threshold: 50}];

  constructor(private park: ParkProvider, private thingUtil: ThingsUtil) {
  }

  ngOnInit() {
    this.isResource = this.thingUtil.isResource(this.thing);
    if (this.isResource) {
      this.hasIcon = true;
      this.icon = this.thingUtil.getIcon(this.thing);
    }
  }

  isCan() {
    return this.thingUtil.isCan(this.thing);
  }

  isTimeBased() {
    return this.thingUtil.isRestroom(this.thing) || this.thingUtil.isTimeBasedTask(this.thing);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/card/card.component.ts